<template>
    <div>
        <b-toast
        id="toast-check-modal-upload-file-teacher"
        variant="none"
        no-close-button
        toaster="b-toaster-top-center"
        >
        <img
          src="@/assets/img/ico-check.png"
          style="margin-right: 10px; margin-top: -2px"
        />
        {{ message }}
        </b-toast>
        <b-toast
        id="toast-equis-modal-upload-file-teacher"
        variant="none"
        no-close-button
        toaster="b-toaster-top-center"
        >
        <img
          src="@/assets/img/ico-equis.png"
          style="margin-right: 10px; margin-top: -2px"
        />
        {{ message }}
        </b-toast>
        <b-breadcrumb>
            <b-breadcrumb-item to="/teacher/class">My Students</b-breadcrumb-item>
            <b-breadcrumb-item @click="returnEvaluationReports">{{dataStudent.name}}: Assignments & Evaluations
            </b-breadcrumb-item>
            <b-breadcrumb-item active>
                <span v-if="this.flagTab">Evaluation Review</span>
                <span v-else>Assignment Review</span>
            </b-breadcrumb-item>
        </b-breadcrumb>
        <div class="card">
            <div class="card-body">
                <div class="back-step mt-0"  @click="backStep">
                    <img class="svg" src="@/assets/icons/icon-arrow-left.svg">{{$t('planesYPrecios.regresar')}}
                </div>
                <h4 class="sub-title">
                    <span v-if="this.flagTab">Evaluation Review</span>
                    <span v-else>Assignment Review</span>
                </h4>
                <b-row class="evaluationCourse" style="width: fit-content;margin: auto;">
                    <b-col class="justify-content-end">
                        <div class="sub-title-img"> 
                            <span class="blue" v-if="this.flagTab">Evaluation:</span>
                            <span class="blue" v-else>Assignment:</span>
                            <p>{{module ? module.id !='-' ? module.strModule : 'Module -' : '-'}}</p>
                            <!--<p>{{dataStudent.name}}</p>
                            <p>{{dataStudent.flag ? `(${dataStudent.groupsCode})`: ''}}</p>-->
                        </div>
                    </b-col>
                    <b-col class="justify-content-start">
                        <div class="sub-title-img name">
                            <img src="@/assets/img/progress-small.png">
                            <div>
                                <span class="blue">Course:</span>
                                 <p >{{nameSubject}}</p>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-row style="margin-top: 45px;">
                    <b-col>
                        <h6 class="bold" style="font-size: 15px;">Comments:</h6>
                        <b-form-group style="margin-bottom: 26px;">
                            <b-form-textarea
                                id="textarea-small"
                                rows="7"
                                placeholder="Enter your comments here."
                                v-model="$v.comment.$model"
                                v-bind:class="{ error: $v.comment.$error}"
                                no-resize>
                            </b-form-textarea>
                            <span class="error-input d-block">{{ validationMsg($v.comment)}}</span>
                        </b-form-group>
                        <div class="d-flex align-items-center">
                            <h6 class="bold mb-0 mr-3" style="font-size: 15px;">Score(*):</h6>
                            <!-- :formatter="format_number" -->
                           
                                <b-form-input v-model="$v.value.$model" type="number" style="background: none !important;"
                                 :formatter="format_number"
                                 :min="startScore" 
                                 :max="endScore" 
                                 :step="step"  
                                 v-bind:class="{ error: $v.value.$error}"
                                 class="w-100"></b-form-input>
                                 
                                
                        </div>
                         <span  class="error-input d-block text-right">{{ validationMsg($v.value)}}</span>
                        <span class="text-small d-block text-right mt-2">{{flagTab ? '(*)' : '' }} The value must be between {{startScore}}-{{endScore}}{{validateScore == 1 ? '' : '%' }}</span>
                    </b-col>
                    <b-col>
                        <h6 class="bold" style="font-size: 15px;">Files:</h6>
                        <template>
                            <VueFileAgent
                                ref="vueFileAgent"
                                :multiple="true"
                                :deletable="true"
                                :meta="true"
                                :accept="SUPPORTEDFILES"
                                :maxSize="'10MB'"
                                :maxFiles="14"
                                :helpText="'Drag and drop files here'"
                                :errorText="{
                                    type: 'Invalid file type. Only images or zip Allowed',
                                    size: 'Files should not exceed 10MB in size',
                                }"
                                @select="filesSelected($event)"
                                @beforedelete="onBeforeDelete($event)"
                                @delete="fileDeleted($event)"
                                v-model="fileRecords"
                            >
                            <template v-slot:after-inner>
                                <p style="line-height: 1.3;margin-bottom: 4px;" :class="fileRecordsForUpload.length >= 1 ? 'mt-3': ''">
                                    Drag and drop files here
                                    <br>
                                    or
                                </p>
                                <b-button class="btn btn-primary">
                                    Browse
                                </b-button>
                            </template >
                            <template v-slot:after-outer>
                                <p class="footer-file-agent">
                                    {{ fileRecords.length }} / 5
                                </p>
                            </template >
                            </VueFileAgent>
                        </template>
                    </b-col>
                </b-row>
                <b-table hover :items="itemsAssignments" :fields="fielAssignments" :busy="isBusy"   :show-empty="true"
                    :empty-text="$t('reusables.empty-text')"
                     :tbody-transition-props="transProps"    style="white-space: pre-line;margin-top: 10px;margin-bottom: 30px;">
                          <template #table-busy>
                    <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> {{$t('ClassRequest.Loading')}}...</strong>
                    </div>
                </template>
                    <template #cell(files)="data">
                        <div>
                            <a class="link noBorder d-flex justify-content-center align-items-center" @click="donwload(data.item.id, data.item.files)">{{data.item.files}} <icon name="arrow-table"  class="ml-2"/></a>
                        </div>
                    </template>
                    <template #cell(feedback)="data">
                        <div>
                            <a class="link noBorder">{{data.item.feedback}}</a>
                        </div>
                    </template>
                    <template #cell(review)>
                        <div @click="goEvaluationsReview" style="width: fit-content;margin: auto;">
                            <img src="@/assets/icons/icon-revision.svg" class="svg">
                        </div>
                    </template>
                </b-table>
                <!--:disabled="$v.value.$invalid || $v.comment.$invalid"-->
                <b-button class="btn btn-primary m-auto d-block" @click="handleSaveFiles" :disabled="$v.value.$invalid || $v.comment.$invalid" >
                     <span v-if="!showSpinnerSave" style="color:#FFFFFF;">Save</span>
                        <b-spinner style="width: 1rem !important; height: 1rem !important; color:#FFFFFF;" v-else label="Spinning">                            
                        </b-spinner>
                </b-button>
            </div>
        </div>
    </div>
</template>
<script>
import * as tools from '@/assets/js/tools.js';
import Vue from 'vue';
import VueFileAgent from 'vue-file-agent';
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import { required, between , requiredIf, decimal , integer   } from 'vuelidate/lib/validators'
import { validationMessage } from "vuelidate-messages";
import axios from 'axios';
import { getNextClassDate } from '@/assets/js/util.js';
import  {SUPPORTEDFILES_HE}  from '@/assets/js/appConstants';
 
const formMessages = {
  required: function(){
    return this.$t('reusables.obligatoryField')
  },
  between: function({
    $params
  }) {
    return `${this.$t('evaluations.enter-number-between')} ${$params.between.min} y ${$params.between.max}`
  },
  isnumber: function(){
    return this.$t('evaluations.have-enter-whole-number')},
}


Vue.use(VueFileAgent);
export default {
  data() {
    return {
      isBusy: false,
      transProps: {
        name: 'flip-list'
      },
      flagHistory: false,
      message: '',
      showSpinnerSave: false,
      gridId: 0,
      registerId: 0,
      groupRegisterSubjectId: 0,
      dataStudent: {},
      groupId: 0,
      groupPlanId: 0,
      value: '',
      last_value: 0,
      validation: {
        min: 0,
        max: 0,
        decimal: 100
      },
      comment: '',
      personStudentId: 0,
      fileRecords: [],
      uploadUrl: 'https://www.mocky.io/v2/5d4fb20b3000005c111099e3',
      uploadHeaders: {
        'X-Test-Header': 'vue-file-agent'
      },
      fileRecordsForUpload: [],
      fielAssignments: [{
          key: 'id',
          label: 'Upload ID'
        },
        {
          key: 'files',
          label: 'Files'
        },
        {
          key: 'date',
          label: 'Date'
        },
      ],
      itemsAssignments: [],
      endScore: 0,
      startScore: 0,
      step: 1,
      validateScore: '',
      listFilesDeleteId: [],
      module: {},
      flagTab: false,
      groupPersonId: 0,
      typeNumber: 1,
      SUPPORTEDFILES: SUPPORTEDFILES_HE.join(",")
    };
  },
  validations: {
    value: {
      isnumber(value) {
        if (this.typeNumber == 1) {
          return integer(value)
        } else {
          return decimal(value)
        }
      },
      between(value) {
        return between(this.startScore, this.endScore)(value)
      },
      required: requiredIf(function(model) {
        return this.flagTab
      })
    },
    /*fileRecordsForUpload: {
        required
    },*/
    comment: {
      required
    },
    validationGroup: ['fileRecordsForUpload', 'comment', 'value']
  },
  created() {

    if (this.$route.params.gridId == undefined) {
      this.$router.push({
        name: 'teacher/class',

      }).catch(err => {});
    } else {

      this.flagHistory = this.$route.params.flagHistory
      this.typeSubject = this.$route.params.typeSubject
      this.groupPlanId = this.$route.params.groupPlanId
      this.gridId = this.$route.params.gridId
      this.groupId = this.$route.params.groupId
      this.personStudentId = this.$route.params.personStudentId
      this.groupRegisterSubjectId = this.$route.params.groupRegisterSubjectId
      this.module = this.$route.params.module
      this.registerId = this.$route.params.registerId
      this.flagTab = this.flagHistory ? false : this.$route.params.flagEvaluation
      this.groupPersonId = this.$route.params.groupPersonId
      this.nameSubject = this.$route.params.nameSubject

      this.getDataStudent();
      this.getDataFile();
    }


  },
  mounted() {

    this.methodSvg();
  },
  computed: {
    User: {
      get() {
        return this.$store.state.user;
      },
      set(value) {
        this.$store.commit('mutateUser', value);
      }
    }
  },
  methods: {
    returnEvaluationReports() {
      let objParams = {
        id: this.$route.params.id,
        flagHistory: this.flagHistory,
        disabledTab: 1,
        groupId: this.groupId,
        personStudentId: this.personStudentId,
        nameSubject: this.nameSubject,
        flagTab: this.flagTab
      };

      this.$router.replace({
        name: 'teacher-student-evaluations-reports',
        params: objParams
      });
    },
    donwload(idFile, fileName) {
      let headers = {
        responseType: "blob"
      };

      baseInstanceAxios
        .get(`${this.apiURL}/Resources/PersonsAssignmentsEvaluations/DownloadFile?idFile=${idFile}`, headers)
        .then((response) => {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(new Blob([response.data]));
          link.setAttribute('download', `${fileName}`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }).catch(() => {});
    },
    format_number(e) {

      /*
      if (e >= this.validation.max) {
      
          return this.validation.max
      } else*/
      if (Math.round(e * this.validation.decimal) / this.validation.decimal != e) {

        return this.last_value
      } else {

        this.last_value = e

        return e
      }


    },
    handleSaveFiles() {
      this.showSpinnerSave = true;
      const formData = new FormData();

      let dataModel = {
        Id: this.gridId,
        GroupRegisterSubjectId: this.groupRegisterSubjectId,
        TypeSubjectId: this.typeSubject,
        FlagEvaluation: this.$route.params.flagEvaluation,
        PersonsStudentId: this.personStudentId,
        TeacherComments: this.comment,
        Score: this.value != '' ? this.value != null ? Number(this.value) : null : null,
        PersonTeacherId: this.User.personTeacherId,
        Module: this.module ? this.module.id == 'N/A' ||  this.module.id == '-' ? null : this.module.id : null,
        UserCreated: this.User.email,
        GroupPersonId: this.groupPersonId
      }



      this.fileRecordsForUpload.forEach(element => {

        formData.append("ListFiles", element.file);
      });

      this.listFilesDeleteId.forEach(element => {
        formData.append("ListFilesIds", element);
      });

      const header = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + this.$store.state.authToken
      }
      let url = ''
      if (this.flagHistory) {
        dataModel.PersonStudentSubjectHistoryId = this.registerId;
        dataModel.GroupPlanId = this.groupPlanId;
        url = `${this.apiURL}/Resources/PersonsAssignmentsEvaluations/SaveByTeacherHistory`
      } else {
        url = `${this.apiURL}/Resources/PersonsAssignmentsEvaluations/SaveByTeacher`
      }

      formData.append("ModelStr", JSON.stringify(dataModel));

      axios({
          method: "POST",
          url: url,
          data: formData,
          headers: header
        })
        .then(response => {

          this.message = this.$t('evaluations.file-upload.message-success');
          this.$bvToast.show("toast-check-modal-upload-file-teacher");
          this.showSpinnerSave = false;
          setTimeout(() => {
            this.backStep();
          }, 500);

        })
        .catch(function(error) {
          this.message = this.$t('my-cours.mesage-system-error');
          this.$bvToast.show("toast-equis-modal-upload-file-teacher");
          this.showSpinnerSave = false;
        });
    },
    validationMsg: validationMessage(formMessages),
    getDataStudent() {
      let data = {
        groupId: this.groupId,
        personStudentId: this.personStudentId
      }

      baseInstanceAxios
        .get(`${this.apiURL}/Resources/PersonsStudents/GetGroupByPersonStudent`, {
          params: data
        })
        .then(response => {

          this.dataStudent = {
            name: response.data.entity.person.strFullName,
            groupsCode: response.data.entity.groupsCode,
            flag: response.data.entity.flagGroup
          }


        });
    },
    getDataFile() {
      this.isBusy = true;
      let data = {
        id: this.gridId,
        groupRegisterSubjectId: this.groupRegisterSubjectId
      }
      let format_day = "MM/DD/YYYY h:mm a";
      baseInstanceAxios
        .get(`${this.apiURL}/Resources/PersonsAssignmentsEvaluations/GetPersonsAssignmentsEvaluationsByFileTeacher`, {
          params: data
        })
        .then(response => {
          //console.log("response.data.entity: ",response.data.entity)
          this.comment = response.data.entity.teacherComments
          if (response.data.entity.listPersonsAssignmentsEvaluationsFiles) {
            this.itemsAssignments = response.data.entity.listPersonsAssignmentsEvaluationsFiles.map(element => ({
              id: element.id,
              files: element.name, // 'CU_ComprasEstudiantes_EA.jpg',
              date: getNextClassDate(element.dateCreated, this.$store.state.user.timeZoneName, this.$moment, format_day),
            }))
          }
          if (response.data.entity.listPersonsAssignmentsEvaluationsFilesTeacher) {
            let lstImages = ['png', 'jpg', 'jpeg']

            this.fileRecords = response.data.entity.listPersonsAssignmentsEvaluationsFilesTeacher.map(element => ({
              id: element.id,
              name: element.name, // 'CU_ComprasEstudiantes_EA.jpg',
              size: 41072,
              type: element.urlFile ? lstImages.includes(element.urlFile.substr(element.urlFile.lastIndexOf('.') + 1)) ? 'image/jpeg' : element.urlFile.substr(element.urlFile.lastIndexOf('.') + 1) : 'pdf',
              url: response.data.entity.routeServer + element.urlFile //'https://english-advance-files-dev.s3.us-east-2.amazonaws.com/usuarios/alumnos/157/136/1/2021/5/CU_ComprasEstudiantes_EA.jpg'

            }))
          }


          //if(response.data.entity.flagEdited){
          // 1 = entero , 2 = decimal,porcentaje

          if (response.data.entity.subject) {
            this.validateScore = response.data.entity.subject.formatScore == "Entero" ? 1 : 2;
            this.typeNumber = this.validateScore
            this.step = response.data.entity.subject.formatScore == 'Entero' ? 1 : 0.01;
            this.startScore = response.data.entity.subject.startScore
            this.endScore = response.data.entity.subject.endScore
          }

          this.value = response.data.entity.score
          this.isBusy = false;

          //}
        });
    },

    methodSvg() {
      //importante para los iconos, arriba esta la importación ----------------
      this.$nextTick(function() {
        tools.imgToSvg()
      })
    },
    uploadFiles: function() {
      // Using the default uploader. You may use another uploader instead.
      this.$refs.vueFileAgent.upload(this.uploadUrl, this.uploadHeaders, this.fileRecordsForUpload);
      this.fileRecordsForUpload = [];
    },
    deleteUploadedFile: function(fileRecord) {
      // Using the default uploader. You may use another uploader instead.
      this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
    },
    filesSelected: function(fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords);
    },
    onBeforeDelete: function(fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1);
      } else {
        if (confirm('Are you sure you want to delete?')) {
          this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
        }
      }
    },
    fileDeleted: function(fileRecord) {

      if (fileRecord.id) {
        this.listFilesDeleteId.push(fileRecord.id)
      }
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1);
      } else {
        this.deleteUploadedFile(fileRecord);
      }
    },
    /*backStep(){
        this.$router.go(-1)
    },*/
    backStep() {
      this.$router.push({
        name: 'teacher-student-evaluations-reports',
        params: {
          id: 1,
          groupId: this.$route.params.groupId,
          nameSubject: this.nameSubject,
          personStudentId: this.$route.params.personStudentId,
          flagHistory: this.flagHistory,
          flagTab: this.flagTab,
          registerId: this.registerId,
          groupPlanId: this.groupPlanId
        }
      })
    },
  }
}
</script>